import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-kt-service-detail-modal',
  templateUrl: './kt-service-detail-modal.component.html',
  standalone: false,
})
export class KtServiceDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<KtServiceDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
  ) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
